import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Task } from "@common/types/task";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { NestedTaskRow } from "../../types";
import { TaskVisibility } from "./TaskVisibility";

/** Org-only column showing which clients can see a task (see `TaskVisibility`). */
export const VisibilityCell = memo(
    ({ row }: CellContext<ViewTableFeatures, NestedTaskRow, unknown>) => {
        const task = row.original as Task;
        if (row.original.isGroup || row.original.isNewPlaceholder) {
            return null;
        }
        return (
            <ViewTableCell>
                <TaskVisibility task={task} />
            </ViewTableCell>
        );
    },
);

VisibilityCell.displayName = "VisibilityCell";
